
import axiosInstance from "../../axiosInstance";
import {
  CreateTaskPayload,
  CreateTaskApiResponse,
  TaskSuccessResponse,
} from "types/project/createTask";
import { normalizeApiError, BusinessError } from "utils/normalizeApiError";

export const createTask = async (
  payload: CreateTaskPayload
): Promise<TaskSuccessResponse> => {
  try {
    const { data } = await axiosInstance.post<CreateTaskApiResponse>(
      "/pmo/add-or-update-work-item",
      payload
    );
    
    if (data.response.status === false) {
      throw new BusinessError(data.response.message || 'Failed to process task');
    }

    return data.response;
  } catch (error) {
    throw normalizeApiError(error);
  }
};
